import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/5-1_infocircle.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const InfoCircle: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default InfoCircle;
